import React from 'react';
import mean from 'lodash/mean';

import { averageFormatter } from '../../../utils/formatters';

import Label from '../../common/Labels/Label';
import useChartData from '../ChartContext';

const DetailRow = ({
  data, label, units, borderColor, 
}) => {
  const rawDataValues = data
    ?.filter(dataPoint => dataPoint !== null)
    ?.map(dataPoint => parseFloat(dataPoint.y));

  const averageValue = rawDataValues?.length ? mean(rawDataValues) : 0;

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-row">
        <div className="p-2 m-2 border rounded" style={{ backgroundColor: borderColor }}/>
        <Label className="mr-2 mt-1" size="lg">Average {label}</Label>
      </div>
      <Label className="mt-1" size="lg" bold>{averageFormatter.format(averageValue)} {units}</Label>
    </div>
  )
}

export const MultiAverageDetailPane = () => {
  const { datasets, units } = useChartData();
  return (
    <div className="flex flex-col mt-2 border border-border-light py-3 px-4">
      {
        datasets.map(({ data, label, borderColor }) => (
          <DetailRow key={label} data={data} label={label} borderColor={borderColor} units={units} />
        ))
      }
    </div>
  );
}

export default MultiAverageDetailPane;
